import Vue from 'vue';
import { Component, Prop, Watch, Emit } from 'vue-property-decorator';

@Component
export class Input extends Vue {
    @Prop({ default: '' }) readonly value!: string | number;

    @Prop({ default: '' }) readonly type!: string;

    @Prop({ default: '' }) readonly label!: string;

    @Prop({ default: '' }) readonly rules!: string;

    @Prop({ default: '' }) readonly description!: string;

    @Prop({ default: '' }) readonly name!: string;

    @Prop({ default: '' }) readonly placeholder!: string;

    localValue = this.value;

    @Emit('input')
    update() {
        return this.localValue;
    }

    @Watch('value')
    onValueChanged(val: string, oldVal: string) {
        this.localValue = val;
    }
}
